import { InsightPanels, InsightPanel } from '../InsightPanels'
import { SkeletonBodyText } from '../../shims/SkeletonBodyTextShim'
import '../../shims/SkeletonBodyTextShim.css'

export type InsightSkeletonKind =
  | 'metric'
  | 'population-steps'
  | 'relationship-list'
  | 'list-group'
  | 'category-breakdown'

/** Geometry only: these lengths carry no measurement, scale or implied result. */
export function InsightCardSkeleton({ kind, rows = 4 }: { kind: InsightSkeletonKind; rows?: number }) {
  if (kind === 'category-breakdown')
    return (
      <s-stack gap="base" data-insight-skeleton-kind={kind}>
        <InsightCardSkeleton kind="metric" />
        {Array.from({ length: rows }, (_, index) => (
          <SkeletonBodyText key={index} lines={2} />
        ))}
      </s-stack>
    )
  if (kind === 'population-steps')
    return (
      <s-query-container data-insight-skeleton-kind={kind}>
        <s-grid gridTemplateColumns="@container (inline-size <= 600px) 1fr, 1fr 1fr 1fr" gap="base">
          {[0, 1, 2].map((index) => (
            <s-stack key={index} gap="small-200">
              <SkeletonBodyText lines={1} />
              <InsightCardSkeleton kind="metric" />
              <SkeletonBodyText lines={1} />
            </s-stack>
          ))}
        </s-grid>
      </s-query-container>
    )
  if (kind === 'list-group')
    return (
      <s-query-container data-insight-skeleton-kind={kind}>
        <InsightPanels collapseBelow={760}>
          {[0, 1].map((index) => (
            <InsightPanel key={index}>
              <InsightCardSkeleton kind="relationship-list" rows={rows} />
            </InsightPanel>
          ))}
        </InsightPanels>
        <SkeletonBodyText lines={3} />
      </s-query-container>
    )
  if (kind === 'relationship-list')
    return (
      <s-stack gap="base" data-insight-skeleton-kind={kind}>
        <InsightCardSkeleton kind="metric" />
        {Array.from({ length: rows }, (_, index) => (
          <s-grid key={index} gridTemplateColumns="104px minmax(0, 1fr)" gap="small">
            <div className="tf-skeleton-placeholder" style={{ inlineSize: 104, blockSize: 80 }} aria-hidden="true">
              <s-box background="subdued" borderRadius="small" inlineSize="100%" blockSize="100%" />
            </div>
            <SkeletonBodyText lines={3} />
          </s-grid>
        ))}
        <SkeletonBodyText lines={2} />
      </s-stack>
    )
  return (
    <s-stack gap="small-200" data-insight-skeleton-kind={kind}>
      <div className="tf-skeleton-placeholder" style={{ width: '6rem' }}>
        <s-box background="subdued" borderRadius="small" inlineSize="100%" blockSize="24px" />
      </div>
      <SkeletonBodyText lines={1} />
    </s-stack>
  )
}
